import { Module } from 'vuex'
import { GlobalDataProps, actionWrapper } from './index'
import { ListData } from './respTypes'

export interface TokenUsageProps {
  // 本次 AI，初始化赠送 / 买会员赠送 / 单独购买 / 消费
  // initial / membership / purchase / resume_create
  type: string;
  // 操作类型，收入还是支持
  operation: 'ADD' | 'SUBTRACT';
  // 本次增加或者消耗的 token 数目
  amount: number;
  // 当前账户剩余的 token 数目
  balance: number;
  // userId 数据库中 user 的关联 id 
  userId: string;

  createdAt?: string;
  updatedAt?: string;
}

export interface TokenProps {
  data: TokenUsageProps[];
  count: number;
}

const balance: Module<TokenProps, GlobalDataProps> = { 
  state: { 
    data: [],
    count: 0
  },
  mutations: {
    getTokenAdmin(state, rawData: ListData<TokenUsageProps[]>) {
      const { data, count } = rawData.data
      state.data = data
      state.count = count
    },
  },
  actions: { 
    getTokenAdmin: actionWrapper('/api/tokensAdmin', 'getTokenAdmin', { disableCaching: true }),
  }
}

export default balance